import { AfterViewInit, Component, ElementRef, Host, Input, OnChanges, OnDestroy, OnInit, Renderer2, inject } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { App } from '@df/core/app';
import { AdvancedCommerceConfigStore } from '@df/module-advanced-commerce/store/advanced-commerce-config.store';
import { AfterContentInitDirective, AfterContentInitDirectiveService } from '@df/ui/common/after-content-init.directive';
import { DfUiModule } from '@df/ui/df-ui.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { AdvancedCommerceProductListingComponent } from '../../../module/advanced-commerce/listing/advanced-commerce-product-listing.component';
import { BreadcrumbsComponent } from '../../../ui/common/breadcrumbs.component';
import { ProductListingComponent } from '../listing/product-listing.component';
import { CategoryViewComponent } from './category-view.component';
import { CategoryHeaderComponent } from './header/category-header.component';
/**
 * Block data interface
 */
export interface ICategoryViewLayoutData extends Catalog.IBlockData<ICategoryViewLayoutContent> {}
/**
 * Block content interface
 */
export interface ICategoryViewLayoutContent {
    /**
     * Top components list
     */
    topComponents: NICmsContentComponent.IData[];
    /**
     * Middle components list
     */
    middleComponents: NICmsContentComponent.IData[];
    /**
     * Bottom components list
     */
    bottomComponents: NICmsContentComponent.IData[];
}
/**
 * Component definition
 */
@Component({
    selector: 'category-view-layout',
    templateUrl: './category-view-layout.html',
    standalone: true,
    imports: [
        AdvancedCommerceProductListingComponent,
        AfterContentInitDirective,
        BreadcrumbsComponent,
        CategoryHeaderComponent,
        DfUiModule,
        ICmsClientModule,
        ProductListingComponent
    ],
    styleUrls: ['./category-view-layout.scss']
})
@ICmsComponent<CategoryViewLayoutComponent>({
    id: 'category-page-layout',
    block: {
        url: 'category-page-layout'
    },
    onDemandOnly: true,
    name: 'Category page layout',
    description: 'Category page layout block',
    fields: [
        {
            type: NICmsContentField.EFieldType.label,
            key: 'label-header',
            title: 'Header part'
        },
        <NICmsContentField.IComponentsField>{
            key: 'topComponents',
            type: NICmsContentField.EFieldType.components,
            title: 'Top components',
            itemName: 'component',
            default: []
        },
        <NICmsContentField.IComponentsField>{
            key: 'middleComponents',
            type: NICmsContentField.EFieldType.components,
            title: 'Middle components, below name',
            itemName: 'component',
            default: []
        },
        {
            type: NICmsContentField.EFieldType.label,
            key: 'label-bottom',
            title: 'Bottom part'
        },
        <NICmsContentField.IComponentsField>{
            key: 'bottomComponents',
            type: NICmsContentField.EFieldType.components,
            title: 'Bottom components',
            itemName: 'component',
            default: []
        }
    ]
})
export class CategoryViewLayoutComponent
    extends UiComponent
    implements NICmsContentComponent.IComponent, OnInit, AfterViewInit, OnChanges, OnDestroy
{
    @ICmsContent({
        type: 'blockContent'
    })
    content: ICategoryViewLayoutContent;

    @Input()
    variant: string;

    protected override canDetach = false;
    protected enabledAc = !!inject(AdvancedCommerceConfigStore)?.config()?.enabled;

    /**
     * Dependencies
     */
    constructor(
        protected elementRef: ElementRef,
        protected renderer2: Renderer2,
        protected app: App,
        private afterContentInit: AfterContentInitDirectiveService,
        @Host()
        public categoryView: CategoryViewComponent
    ) {
        super();
    }
    override ngOnInit(): void {
        this.afterContentInit.lock(this);
        super.ngOnInit();
    }
    ngAfterViewInit(): void {
        this.timeoutService.setTimeout(() => {
            this.afterContentInit.unlock(this);
        }, 1000);
    }
    /**
     * Category shorthand
     */
    get category() {
        return this.categoryView.model;
    }
    /////////////////// HELPERS ////////////////////
    override detectChanges() {
        this.client.isCms ? this.categoryView.detectChanges() : super.detectChanges();
    }
}
